<template>
  <div class="frontend-router-spec">
    <pre>{{ routesJson }}</pre>
  </div>
</template>


<script>
export default {
  data() {
    return {
      routesJson: '',
    };
  },
  created() {
    this.routesJson = JSON.stringify(
      this.serializeRoutes(this.$router.options.routes),
      null,
      2
    );
  },
  methods: {
    serializeRoutes(routes) {
      if (!Array.isArray(routes)) return [];
      return routes.map(route => this.serializeRoute(route));
    },
    serializeRoute(route) {
      const out = { path: route.path };

      if (route.name) out.name = route.name;

      if (route.redirect !== undefined) {
        if (typeof route.redirect === 'function') {
          out.redirect = '(function)';
        } else if (
          route.redirect &&
          typeof route.redirect === 'object' &&
          route.redirect.name
        ) {
          out.redirect = { name: route.redirect.name };
        } else {
          out.redirect = route.redirect;
        }
      }

      if (typeof route.beforeEnter === 'function') {
        out.hasBeforeEnter = true;
      }

      if (Array.isArray(route.children) && route.children.length) {
        out.children = this.serializeRoutes(route.children);
      }

      return out;
    },
  },
};
</script>


<style lang="scss" scoped>
.frontend-router-spec {
  min-height: 100vh;
  background: #fff;
  color: #111;
  padding: 24px;
  overflow: auto;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
  line-height: 1.5;

  pre {
    margin: 0;
    white-space: pre;
  }
}
</style>
